import type { FC } from "react"
import { Navigate, Outlet, useLocation } from "react-router"

import { useCurrentUser } from "@/lib/useCurrentUser"

export const AuthenticatedLayout: FC = () => {
  const currentUser = useCurrentUser()
  const location = useLocation()

  if (!currentUser) {
    return (
      <Navigate
        to={`/login?continue_url=${location.pathname}`}
        replace
        state={{ from: location }}
      />
    )
  }

  return <Outlet />
}
